var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"default-user-avatar",class:{
          ['avatar-' + _vm.color]: _vm.bgColor == '',
          [`${_vm.bgColor}`]: _vm.bgColor != '',
          [`md:mx-auto`]: _vm.isLoggedOut
      },style:({
          width: _vm.size + 'px',
          height: _vm.size + 'px',
          'font-size': _vm.fontSize,
      })},[_c('span',[_vm._v(_vm._s(_vm.initials))])])
}
var staticRenderFns = []

export { render, staticRenderFns }